"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
const tutors = [{
  id: 1,
  name: "Neb",
  subject: "Science & Maths",
  image: "https://educationfamilytutors.com/wp-content/uploads/2026/02/90a44b02-a1c6-4663-850a-ec6e11cf828d.png?v=r85tu3urxx",
  bio: "Neb is the founder of Education Family Tutors and has been a qualified Science teacher for the past 10 years. During that time he has also regularly tutored Science and Maths at all levels. He has extracted the best from his experience to create the perfect solution via Education Family Tutors, combining both academic tutoring and mindset coaching."
}];
export default function MeetTheTeam() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  return <section ref={ref} className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <h2 className="font-display text-foreground mb-12 text-center text-3xl font-bold sm:text-4xl">
          Meet the Team
        </h2>

        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {tutors.map((tutor, i) => <Card key={tutor.id} data-index={i} className={`hover-lift border-border shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? i === 0 ? "animate-fade-in-up" : i === 1 ? "animate-fade-in-up-delay-100" : "animate-fade-in-up-delay-200" : "opacity-0"}`}>
              <CardHeader className="items-center gap-4">
                <SafeHydrate><Avatar className="size-24 shadow-soft ring-2 ring-border">
                  <AvatarImage src={tutor.image} alt={tutor.name} />
                  <AvatarFallback className="bg-primary text-foreground-primary text-xl font-semibold">
                    {tutor.name.split(" ").map(n => n[0]).join("")}
                  </AvatarFallback>
                </Avatar></SafeHydrate>

                <div className="flex flex-col items-center gap-2">
                  <CardTitle className="text-foreground text-lg">
                    {tutor.name}
                  </CardTitle>
                  <Badge variant="secondary" className="text-xs">
                    {tutor.subject}
                  </Badge>
                </div>
              </CardHeader>

              <CardContent>
                <Accordion type="single" collapsible>
                  <AccordionItem value="bio" className="border-none">
                    <AccordionTrigger className="text-foreground hover:no-underline py-2 text-sm font-semibold">
                      Read Bio
                    </AccordionTrigger>
                    <AccordionContent className="text-muted-foreground text-sm leading-relaxed">
                      {tutor.bio}
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}